import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SearchRoutingService } from './services/search-routing.service';
import { SearchStateMappingService } from './services/search-state-mapping.service';

@NgModule({
  imports: [CommonModule, RouterModule],
  providers: [SearchRoutingService, SearchStateMappingService]
})
export class SearchModule {}
